import { z } from 'zod';

const reportTypesEnum = z.enum(['office', 'management', 'creditor', 'teams']);

type bla = z.output<typeof reportTypesEnum>;

export const reportSchemaValidator = z.string().refine(value => {
  if (typeof value !== 'string') return false;
  const parts = value.split(',');
  return parts.every(part =>
    reportTypesEnum['_def'].values.includes(part.trim() as z.infer<typeof reportTypesEnum>),
  );
});
